module.exports = {
  data() {
    return {
      defaultSearchParam: {}, // 默认的搜索参数
      searchParam: {}, // 过滤的参数
      searchParams: {}, //我的收藏页面参数
    };
  },
  methods: {
    // 处理table插槽中返回的回调
    handlerActionClick(params) {
      if (!params) return;
      const { cb, row } = params;
      if (this[cb]) {
        // 只有函数存在才执行
        this[cb](row);
      } else {
        console.error(`function name : ${cb} is not defined, please check it`);
      }
    },
    // 处理滚动条
    updateTableScrollOpt() {
      const ref = this.$refs.table;
      if (ref) {
        const updateScrollOpt = this.$refs.table.updateScrollOpt();
        this.$nextTick(updateScrollOpt);
      }
    },
    // 处理表格的加载状态
    loadingTable(v) {
      const ref = this.$refs.table;
      if (ref) {
        this.$refs.table.settingLoading(v);
      }
    },
    // 清空勾选
    initSelectedRowIds() {
      this.$refs.table.selectedRowIds = [];
      this.$refs.table.selectedRowKeys = [];
    },
  },
};
